import styled from "styled-components";
import React from "react";

export const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 10px;
`;

const StyledBtn = styled.button`
    appearance: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    background: #fff;
    color: #374151;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
    transition: background 120ms ease, border-color 120ms ease, color 120ms ease;

    &:hover {
        background: #f5f3ff;
        border-color: #c7d2fe;
        color: #4f46e5;
    }
    &:focus { outline: none; }
    &:focus-visible { box-shadow: 0 0 0 3px rgba(99,102,241,.25); }
`;

export function ButtonWithIcon({ tag: Tag, to, onClick, id, icon: Icon, children }) {
    if (Tag) {
        return (
            <StyledBtn as={Tag} to={to} id={id}>
                {Icon && <Icon size="14" />}
                {children}
            </StyledBtn>
        );
    }
    return (
        <StyledBtn onClick={onClick} id={id}>
            {Icon && <Icon size="14" />}
            {children}
        </StyledBtn>
    );
}
